export const WEBEX_API_BASE = "https://webexapis.com/v1";
export const WEBEX_WEBHOOKS_ENDPOINT = `${WEBEX_API_BASE}/webhooks`;
export const WEBEX_MESSAGES_ENDPOINT = `${WEBEX_API_BASE}/messages`;
export const WEBEX_PEOPLE_ENDPOINT = `${WEBEX_API_BASE}/people`;
export const WEBEX_ROOMS_ENDPOINT = `${WEBEX_API_BASE}/rooms`;
export const WEBEX_MEMBERSHIP_ENDPOINT = `${WEBEX_API_BASE}/memberships`;
export const WEBEX_AUTH_ENDPOINT = `${WEBEX_API_BASE}/authorize`;
export const WEBEX_TOKEN_ENDPOINT = `${WEBEX_API_BASE}/access_token`;
export const WEBEX_ATTACHMENT_ACTIONS = `${WEBEX_API_BASE}/attachment/actions`;
export const REQUIRED_WEBEX_SCOPES = ["spark:all"] as const;
